import * as React from "react";
import { useMemo } from "react";
import { SAVE_COPY } from "views/components/contexts/SearchPageLayoutContext";
import SearchPage from "views/pages/SearchPage";
import SearchPageLayoutProvider from "views/components/contexts/SearchPageLayoutProvider";
import ViewDeserializer from "views/logic/views/ViewDeserializer";
const DynamicSearch = ({
  viewJson,
  SearchAreaContainer = void 0
}) => {
  const view = useMemo(() => ViewDeserializer(viewJson), [viewJson]);
  const searchPageLayout = useMemo(
    () => ({
      sidebar: { isShown: false },
      viewActions: SAVE_COPY,
      searchAreaContainer: { component: SearchAreaContainer }
    }),
    [SearchAreaContainer]
  );
  return /* @__PURE__ */ React.createElement(SearchPageLayoutProvider, { value: searchPageLayout }, /* @__PURE__ */ React.createElement(SearchPage, { view: Promise.resolve(view), isNew: false }));
};
export default DynamicSearch;
